export default "__VITE_ASSET__742a06fc__"